import React from 'react';
import {
  Bag,
  Bricks,
  Car,
  Circles,
  Equipment,
  Flower,
  Ladder,
  Sprout,
  Sun,
  Timer,
  User,
  Wheelbarrow,
} from './icons';

export const gcContent = [
  {
    icon: <Sun size="32" />,
    text: 'Сезоннные товары',
  },
  {
    icon: <User size="32" />,
    text: 'Уникальные услуги',
  },
  {
    icon: <Sprout size="32" />,
    text: 'Обустройство сада и огорода',
  },
  {
    icon: <Ladder size="32" />,
    text: 'Все для отдыха на даче',
  },
  {
    icon: <Flower size="32" />,
    text: 'Растения, саженцы, рассада',
  },
  {
    icon: <Equipment size="32" />,
    text: 'Все для работы в саду',
  },
];

export const byContent = [
  {
    icon: <Car size="32" />,
    text: 'Формат DriveIn',
  },
  {
    icon: <Circles size="32" />,
    text: 'Расширенный ассортимент',
  },
  {
    icon: <Timer size="32" />,
    text: 'Ускоренная сборка и обработка заказов',
  },
  {
    icon: <Bricks size="32" />,
    text: 'Материалы для строительства',
  },
  {
    icon: <Wheelbarrow size="32" />,
    text: 'Строительное оборудование',
  },
  {
    icon: <Bag size="32" />,
    text: 'Расходные материалы',
  },
];
